export interface IntakeValidationErrorItem {
  id: string;
  label: string;
  /** Shown after the label as ": {detail}" when present. */
  detail?: string;
  onClick?: () => void;
}

/**
 * Map react-hook-form field errors to clickable validation list items.
 *
 * `labelOverrides` maps a field name to a fixed display label, for fields whose
 * rule-violation messages are too long for the summary list — the full message
 * still renders inline under the field itself.
 */
export function formErrorsToValidationItems(
  errors: Record<string, unknown>,
  onScrollToField?: (fieldName: string) => void,
  labelOverrides?: Record<string, string>
): IntakeValidationErrorItem[] {
  return Object.entries(errors)
    .map(([fieldName, error]) => {
      const message = (error as { message?: string })?.message ?? '';
      const cleanedMessage = message.replace(/ is required$/, '');
      const label =
        labelOverrides?.[fieldName] ?? (cleanedMessage || fieldName);
      return {
        id: fieldName,
        label,
        onClick: onScrollToField ? () => onScrollToField(fieldName) : undefined,
      };
    })
    .filter(item => item.label !== '');
}
